import Vue from 'vue'
import Vuex from 'vuex'

import mars from './modules/mars'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        mars
    },
    getters
})

export default store
